// Import Wallet Icons
import Phantom from "../assets/walletIcons/phantom.svg";
import Coin98 from "../assets/walletIcons/coin98.svg";
import Solflare from "../assets/walletIcons/solflare.svg";
import Math from "../assets/walletIcons/math.svg";
import SafePal from "../assets/walletIcons/safepal.svg";

export const Wallets = [
  {
    name:"Phantom",
    icon: Phantom,
    provider: "phantom",
    url: "phantom.app"
  },
  {
    name:"Coin98 Wallet",
    icon: Coin98,
    provider: "coin98",
    url: "wallet.coin98.com"
  },
  {
    name:"Solflare Wallet",
    icon: Solflare,
    provider: "solflare",
    url: "solflare.com"
  },
  {
    name:"Solflare Extension",
    icon: Solflare,
    provider: "solflareExtension",
    url: "solflare.com"
  },
  {
    name:"SafePal",
    icon: SafePal,
    provider: "safepal",
    url: "safepal.io"
  },
  {
    name:"Math Wallet",
    icon: Math,
    provider: "math",
    url: "wathwallet.org"
  }
];
